/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { Button, Form, Select, Input, Switch, Card, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from '../../../components/Header';
import Sidebar from '../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { ActionGetRoomTypeOptions, ActionCreateRoom, ActionUpdateRoom, ActionGetRoomByID } from '../../../store/Actions/MasterDataAction';
import queryString from 'query-string';

const AddNewRoom = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const params = queryString.parse(location.search);
    const updateValue = params.update;
    const idValue = params.id;
    const isUpdate = updateValue === 'true' && idValue;

    const { roomTypeOptions, room } = useSelector(state => state?.MasterData);

    useEffect(() => {
        // Fetch room type options for dropdown
        dispatch(ActionGetRoomTypeOptions({ Query: '?action=get_options' }));

        // If updating, fetch room details
        if (isUpdate && idValue) {
            dispatch(ActionGetRoomByID({ Query: `/${idValue}` }));
        }
    }, [dispatch, isUpdate, idValue]);

    // Set form values when room data is loaded for update
    useEffect(() => {
        if (isUpdate && room && room._id) {
            form.setFieldsValue({
                roomNo: room.roomNo,
                roomTypeId: room.roomTypeId?._id || room.roomTypeId,
                isActive: room.isActive !== undefined ? room.isActive : true,
                allowedGender: room.allowedGender || undefined,
            });
        }
    }, [room, isUpdate, form]);

    const onFinish = (values) => {
        setLoading(true);

        const payload = {
            roomNo: values.roomNo,
            roomTypeId: values.roomTypeId,
            isActive: values.isActive !== undefined ? values.isActive : true,
            allowedGender: values.allowedGender,
        };

        if (isUpdate) {
            // Update room
            dispatch(ActionUpdateRoom({ Query: `/${idValue}`, obj: payload }, (res) => {
                setLoading(false);
                if (res?.statusCode === 200 || res?.success === true) {
                    message.success('Room updated successfully');
                    navigate('/new-room');
                } else {
                    message.error(res?.message || 'Failed to update room');
                }
            }));
        } else {
            // Create new room
            dispatch(ActionCreateRoom(payload, (res) => {
                setLoading(false);
                if (res?.statusCode === 201 || res?.statusCode === 200 || res?.success === true) {
                    message.success('Room created successfully');
                    navigate('/new-room');
                } else {
                    message.error(res?.message || 'Failed to create room');
                }
            }));
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/new-room">Rooms</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right">
                                            <FeatherIcon icon="chevron-right" />
                                        </i>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        {isUpdate ? 'Edit Room' : 'Add New Room'}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <Card title={isUpdate ? 'Edit Room' : 'Add New Room'}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    initialValues={{
                                        isActive: true,
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <Form.Item
                                                name="roomNo"
                                                label="Room Number"
                                                rules={[
                                                    { required: true, message: 'Please enter room number' },
                                                    { whitespace: true, message: 'Room number cannot be empty' }
                                                ]}
                                            >
                                                <Input
                                                    placeholder="Enter Room Number (e.g., Brahmi, Semi deluxe 1)"
                                                    size="large"
                                                />
                                            </Form.Item>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <Form.Item
                                                name="roomTypeId"
                                                label="Room Type"
                                                rules={[{ required: true, message: 'Please select room type' }]}
                                            >
                                                <Select
                                                    placeholder="Select Room Type"
                                                    size="large"
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                >
                                                    {roomTypeOptions?.map((item, index) => {
                                                        const val = item.value || item.id || item._id;
                                                        const label = item.label || item.name?.en || item.name;
                                                        return (
                                                            <Select.Option key={index} value={String(val)}>
                                                                {label}
                                                            </Select.Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <Form.Item
                                                name="allowedGender"
                                                label="Allowed Gender"
                                            >
                                                <Select
                                                    placeholder="Select Allowed Gender"
                                                    size="large"
                                                    allowClear
                                                >
                                                    <Select.Option value="Male">Male</Select.Option>
                                                    <Select.Option value="Female">Female</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <Form.Item
                                                name="isActive"
                                                label="Active Status"
                                                valuePropName="checked"
                                            >
                                                <Switch
                                                    checkedChildren="Active"
                                                    unCheckedChildren="Inactive"
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <div className="doctor-submit text-end">
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    loading={loading}
                                                    className="btn btn-primary submit-form me-2"
                                                >
                                                    {isUpdate ? 'Update' : 'Submit'}
                                                </Button>
                                                <Button
                                                    type="default"
                                                    onClick={() => navigate('/new-room')}
                                                    className="btn btn-primary cancel-form"
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddNewRoom;